<template>
<div
  class="documents-print"
  v-if="loaded"
>
  <div
    v-for="ticket in tickets"
    :key="ticket._id"
  >
    <lending-term
      v-if="config.state === 'MA' && eventPrintLending"
      :companyTerms="event.doc.companyTerms"
      :state="config.state"
      :ticket="ticket"
      :customer="customers[ticket.customerId]"
      :config="config"
      :manufacturer="getManufacturer(ticket.stockId)"
    />

    <div
      v-if="config.state === 'MA' && eventPrintLending"
      class="page-break"
    ></div>

    <delivery-term
      :companyTerms="event.doc.companyTerms"
      :ticket="ticket"
      :manufacturer="getManufacturer(ticket.stockId)"
      :stock="stocks[ticket.stockId]"
      :customer="customers[ticket.customerId]"
      :config="config"
      :dateTimeDelivery="event.dateTimeDelivery"
    />
    <div class="page-break"></div>
  </div>
</div>
<div v-else>
  <h3>Carregando dados...</h3>
</div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import DeliveryTerm from '../Documents/Terms/DeliveryTerm'
import LendingTerm from '../Documents/Terms/LendingTerm'

export default {
  name: 'DocumentsPrint',
  components: {
    LendingTerm,
    DeliveryTerm
  },
  data () {
    return {
      loaded: false
    }
  },
  watch: {
    tickets () {
      console.log('watch')
      // if (this.tickets.length > 0 && this.checkAllStocks()) {
      //   console.log('watch')
      //   this.runPrint()
      // }
    }
  },

  computed: {
    ...mapGetters('project', {config: 'project'}),
    ...mapGetters('manufacturers', {
      manufacturers: 'modelById'
    }),
    ...mapGetters('surveys', {
      surveys: 'modelById'
    }),
    ...mapGetters('customers', {
      customers: 'modelById'
    }),
    ...mapGetters('stocks', {
      stocks: 'modelById'
    }),
    ...mapGetters('tickets', {
      tickets: 'tickets'
    }),
    ...mapGetters('events', {
      event: 'event',
      eventPrintLending: 'eventPrintLending'
    }),

    eventId () {
      return this.$route.params.eventId
    },

    ticketId () {
      return this.$route.params.ticketId
    }
  },

  methods: {
    ...mapActions('tickets', {
      fetchTickets: 'fetchAll',
      fetchTicket: 'fetchOne',
      setTickets: 'setStateAll'
    }),

    ...mapActions('events', {
      fetchEvent: 'fetchOne'
    }),

    ...mapActions('stocks', {
      fetchStocksByIds: 'fetchIds'
    }),

    ...mapActions('manufacturers', {
      fetchManufacturersByIds: 'fetchIds',
      fetchManufacturers: 'fetchAll'
    }),

    ...mapActions('customers', {
      fetchCustomersById: 'fetchIds'
    }),

    runPrint () {
      window.setTimeout(() => {
      }, 2000)
    },
    checkAllStocks () {
      for (let t in this.tickets) {
        if (!this.tickets[t].stockId || !this.stocks[this.tickets[t].stockId]) {
          return false
        }
      }
      return true
    },

    fetch () {
      return Promise.all([
        this.getTickets(),
        this.fetchEvent(this.eventId)
      ]).then(results => {
        const dataIds = this.getStockCustomersIds(results[0])
        return this.fetchPromiseCustomerStocks([
          this.fetchStocksByIds({
            connection: 'default',
            ids: dataIds.stockIds.map(item => Object.assign({}, {id: item}))
          }),
          this.fetchCustomersById({
            connection: 'default',
            ids: dataIds.customerIds.map(item => Object.assign({}, {id: item}))
          })
        ])
      }).catch(e => console.log(e))
    },

    fetchPromiseCustomerStocks (promises) {
      return Promise.all(promises)
        .then(() => {
          this.loaded = true
        })
    },

    getStockCustomersIds (tickets) {
      if (tickets instanceof Array) {
        const stockIds = []
        const customerIds = []
        for (let ticket of tickets) {
          stockIds.push(ticket.stockId)
          customerIds.push(ticket.customerId)
        }
        return {
          stockIds,
          customerIds
        }
      }
    },

    getTickets () {
      if (this.ticketId !== null && this.ticketId !== 'none') {
        return this.fetchTicket(this.ticketId)
          .then(res => {
            this.setTickets([res])
            return [res]
          })
      }

      return this.fetchTickets({
        where: {
          eventId: this.eventId,
          winner: true,
          '$and': [{stockId: {'$exists': true}}, {stockId: {'$ne': null}}]
        },
        sort: {field: 'createdAt', direction: 'desc'}
      })
    },

    getManufacturer (stockId) {
      if (!this.stocks.hasOwnProperty(stockId)) {
        return {}
      }
      if (!this.manufacturers.hasOwnProperty(this.stocks[stockId].manufacturerId)) {
        return {}
      }

      return this.manufacturers[this.stocks[stockId].manufacturerId]
    }
  },

  mounted () {
    this.fetchManufacturers({limit: 9999})
    this.fetch()
  }
}
</script>
<style scoped>
  @media print {
    .page-break {
      page-break-after: always;
    }
  }

  strong {
    font-weight: bolder;
  }

  @page {
    size: A4 portrait;
    margin: 1em;  /* this affects the margin in the printer settings */
  }

</style>



// WEBPACK FOOTER //
// src/pages/Documents/DocumentsPrint.vue